function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo, forwardRef } from "react";
import PropTypes from "prop-types";
import { HtmlRenderer, JsonRenderer } from "./renderers";
import { ErrorBoundary } from "../utilities/ErrorBoundary";
import { useMboxCache, isDone } from "./cache/mboxes";
import { FOOCMask } from "../utilities/FOOCMask";
import { withDebugger } from "./RemoteDebugger";
import { useTrackMboxWithSatellite } from "../../providers/satellite";
import logger from "../../logger";
// Added imports for cachev2 feature test
import { LPEHOC } from "../LPEHOC";
import { getFlag, getPersonalizationClientId } from "../../utils/ld-cache";
import useURL from "../../hooks/useURL";
var Renderer = /*#__PURE__*/ forwardRef(function Renderer(props, ref) {
    var cachedMbox = props.cachedMbox;
    var tmp = cachedMbox.options, _ref = _sliced_to_array(tmp === void 0 ? [
        {}
    ] : tmp, 1), _ref_ = _ref[0], type = _ref_.type, content = _ref_.content;
    // <Special Case Handler> for Adobe Target Remote Offers which return as type html but contain json payloads
    try {
        // fields is a object level definition of props from Contentful payload
        var fields = JSON.parse(content).fields;
        if (fields) {
            content = fields;
            type = "json";
        }
    } catch (err) {
    // Continue
    }
    // </Special Case Handler>
    switch(type){
        case "html":
            {
                return /*#__PURE__*/ _jsx(HtmlRenderer, _extends({}, props, {
                    content: content
                }));
            }
        case "json":
            {
                return /*#__PURE__*/ _jsx(JsonRenderer, _extends({}, props, {
                    content: content,
                    ref: ref
                }));
            }
        default:
            throw new Error("Attempting to render unsupported content type");
    }
});
Renderer.propTypes = {
    cachedMbox: PropTypes.object.isRequired
};
var AdobeTarget = /*#__PURE__*/ forwardRef(function AdobeTarget(props, ref) {
    var name = props.name, parameters = props.parameters, overrideResponseProps = props.overrideResponseProps; // TODO make const
    var mbox = props.mbox, mboxParams = props.mboxParams, mapToChildren = props.mapToChildren, profileParameters = props.profileParameters, _props_children = props.children, children = _props_children === void 0 ? null : _props_children, _props_disableFoocMask = props.disableFoocMask, disableFoocMask = _props_disableFoocMask === void 0 ? true : _props_disableFoocMask, timeout = props.timeout;
    var fallback = useMemo(function() {
        return children;
    }, [
        children
    ]);
    if (mbox || mboxParams || mapToChildren) {
        logger.warn('AdobeTarget "' + (mbox || name) + '" props (mbox, mboxParams, mapToChildren) have been deprecated\nplease use props (name, parameters, overrideResponseProps) respectfully.');
    }
    if (!name) name = mbox;
    if (!parameters) parameters = mboxParams;
    if (!overrideResponseProps) overrideResponseProps = mapToChildren;
    if (typeof name !== "string" || name.length === 0) {
        logger.error("Expected prop `name` to be a string with length > 0");
    }
    var _useMboxCache = useMboxCache({
        name: name,
        parameters: parameters,
        profileParameters: profileParameters
    }), _useMboxCache_cachedMbox = _useMboxCache.cachedMbox, cachedMbox = _useMboxCache_cachedMbox === void 0 ? {} : _useMboxCache_cachedMbox;
    // Options can be returned from target, if it has no type it is default content.
    var tmp = cachedMbox.options, _ref = _sliced_to_array(tmp === void 0 ? [] : tmp, 1), tmp1 = _ref[0], type = (tmp1 === void 0 ? {} : tmp1).type;
    useTrackMboxWithSatellite(cachedMbox);
    return /*#__PURE__*/ _jsx(FOOCMask, {
        timeout: timeout,
        hide: !disableFoocMask && isDone(cachedMbox) === false,
        children: type ? /*#__PURE__*/ _jsx(ErrorBoundary, {
            name: name,
            fallback: fallback,
            children: /*#__PURE__*/ _jsx(Renderer, _extends({}, props, {
                cachedMbox: cachedMbox,
                name: name,
                overrideResponseProps: overrideResponseProps,
                ref: ref
            }))
        }) : fallback
    });
});
AdobeTarget.propTypes = {
    mbox: PropTypes.string,
    mboxParams: PropTypes.object,
    name: PropTypes.string,
    parameters: PropTypes.object,
    disableFoocMask: PropTypes.bool,
    overrideResponseProps: PropTypes.object
};
AdobeTarget.defaultProps = {
    mbox: null,
    mboxParams: null,
    name: null,
    parameters: {},
    disableFoocMask: null,
    overrideResponseProps: null
};
var AdobeTargetWithDebugger = withDebugger(AdobeTarget);
var AdobeTargetWithLPEHOC = /*#__PURE__*/ forwardRef(function ABTestWrapperWithDynamic(props, ref) {
    // Using getFlag instead of useLaunchDarklyFlag to avoid adding anything to the cache
    // We only want to do this if the flag came from server side rendering
    var useNewCache = getFlag("replace-lapel-legacy-cache", false, getPersonalizationClientId());
    var url = useURL();
    var name = props.name, parameters = props.parameters, profileParameters = props.profileParameters;
    var entryConfig = useMemo(function() {
        return {
            name: name,
            parameters: parameters,
            profileParameters: profileParameters,
            path: url
        };
    }, [
        name,
        parameters,
        profileParameters,
        url
    ]);
    if (useNewCache) {
        return /*#__PURE__*/ _jsx(LPEHOC, _extends({}, props, {
            config: entryConfig,
            ref: ref
        }));
    }
    return /*#__PURE__*/ _jsx(AdobeTargetWithDebugger, _extends({}, props, {
        ref: ref
    }));
});
export { AdobeTargetWithLPEHOC as AdobeTarget };

//# sourceMappingURL=AdobeTarget.js.map